module.exports = __webpack_public_path__ + "static/logo225a.4d1b23e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo225a.png
// module id = 131
// module chunks = 114276838955818 162898551421021